import React from 'react';
import { useScrollToTop } from '../hooks/useScrollToTop';
import { useLocation } from 'react-router-dom';

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  useScrollToTop();
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <main className="relative min-h-screen">
      <div className={`relative z-10 ${isHomePage ? '' : 'pt-16'}`}>
        {children}
      </div>
    </main>
  );
}